<!--
 * @LastEditors: 杨钊
 * @Date: 2020-04-25 13:48:33
 * @LastEditTime: 2020-05-04 17:42:27
 * @FilePath: /tiger-web/src/components/Global.vue
 -->
<template></template>
<script>
// const HTTP_SERVER = window.location.protocol+"//"+window.location.host+"/";
// const WEB_SOCKET_SERVER = "wss://"+window.location.host;
// const SHORT_LINK_PREFIX = window.location.protocol+"//"+window.location.host+"/";
// const FILE_SERVER = "https://file.dahengapp.com";

const HTTP_SERVER = "https://dahengapp.com/";
const WEB_SOCKET_SERVER = "wss://dahengapp.com";
const SHORT_LINK_PREFIX = "https://dahengapp.com/";
const FILE_SERVER = "https://file.dahengapp.com";

// const HTTP_SERVER = "http://127.0.0.1:8080";
// const WEB_SOCKET_SERVER = "ws://127.0.0.1:8080";
// const SHORT_LINK_PREFIX = "http://127.0.0.1:8080/";
// const FILE_SERVER = "http://127.0.0.1:8080";

const UPLOAD_PKG_SIZE = "2G";
const APP_NAME = "大亨游戏";
const QQ = "";
const QQ_TUIGUANG = "";
export default {
  HTTP_SERVER,
  SHORT_LINK_PREFIX,
  WEB_SOCKET_SERVER,
  APP_NAME,
  QQ,
  QQ_TUIGUANG,
  UPLOAD_PKG_SIZE,
  FILE_SERVER,
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Global.vue